import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RepPage } from "@/features/sales/RepPage";

// ?person=<id>&period=day|week|month|quarter: whose numbers, for which period (the month when none is given)
const search = z.object({
  person: z.string().optional(),
  period: z.enum(["day", "week", "month", "quarter"]).catch("month"),
});

export const Route = createFileRoute("/_app/sales/rep")({
  validateSearch: search,
  component: () => {
    const s = Route.useSearch();
    return <RepPage person={s.person} period={s.period} />;
  },
});
